/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import {
	TableCell,
	TableRow,
	Typography,
	Stack,
	Skeleton,
	Checkbox,
	useTheme,
} from '@mui/material';
import { lighten } from '@mui/material/styles';
import RenderRenewalStatusCell from './PolicyTransactionTable/PolicyTransactionDataGrid/RenderRenewalStatusCell';
import { useParams } from 'react-router-dom';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';

export const DealPolicyRow = ({ hit: deal, handleCheckboxChange, selectedDeal }) => {
	const theme = useTheme();
	const { dealId } = useParams();

	const { data: dealRow } = useGetDealRowQuery(deal?.id, {
		skip: !dealId,
	});

	const showDisabled = deal?.id === dealId;

	const policies = useMemo(
		() => (deal?.policies ?? []).filter((p) => Object.keys(p ?? {}).length > 0),
		[deal?.policies],
	);

	const getUniquePolicies = () => {
		const unique = {};
		policies.forEach((policy) => {
			if (!unique[policy.Id]) {
				unique[policy.Id] = policy;
			}
		});
		return Object.values(unique);
	};
	const uniquePolicies = getUniquePolicies();

	const isLoading = deal?.policiesLoading;

	return (
		<TableRow
			key={`table-row-${dealId}`}
			sx={{
				...(showDisabled && {
					backgroundColor: theme.palette.action.disabledBackground,
				}),
			}}
		>
			<TableCell width={'5%'}>
				<Checkbox
					key={`checkbox-${deal?.id}`}
					checked={selectedDeal.includes(deal?.id) || showDisabled}
					onChange={(event) => handleCheckboxChange(event, deal?.id)}
					color='primary'
					disabled={showDisabled}
					sx={{
						'&.Mui-checked': {
							color: theme.palette.primary.main,
						},
						'&:hover': {
							backgroundColor: lighten(theme.palette.primary.main, 0.9),
							'&:not(.Mui-checked)': {
								color: lighten(theme.palette.primary.main, 0.3),
							},
						},
						'&.Mui-disabled': {
							color: theme.palette.action.disabled,
						},
					}}
				/>
			</TableCell>
			<TableCell width={'5%'}>
				<Typography>{dealRow?.yearFolder}</Typography>
			</TableCell>
			<TableCell width={'10%'}>
				<Typography>{dealRow?.dealName}</Typography>
			</TableCell>
			<TableCell width={'20%'}>
				{isLoading ? (
					<Skeleton width='100%' />
				) : policies.length > 0 ? (
					<Stack direction='column'>
						{uniquePolicies.map((policy, i) => {
							const policyData = policy.policy || policy;
							return (
								<Stack
									direction={'row'}
									key={`${deal.id}-policy-${i}-${policyData.Id}`}
								>
									<Typography>
										{`${policyData.ClassOfRisk || policyData.classOfRisk || '-'} - ${policyData.PolicyNumber || policyData.policyNumber || '-'}`}
									</Typography>
								</Stack>
							);
						})}
					</Stack>
				) : (
					<Typography sx={{ fontSize: '13px', color: theme.palette.text.secondary }}>
						{'No policies linked'}
					</Typography>
				)}
			</TableCell>
			<TableCell width={'10%'}>
				{isLoading ? <Skeleton width='100%' /> : <RenderRenewalStatusCell row={deal} />}
			</TableCell>
		</TableRow>
	);
};
